import { useState } from "react"
import { computed } from "mobx"
import { observer } from "mobx-react"
import { Button, Skeleton, Table } from "antd"
import { ColumnsType } from "antd/es/table"
import { DeleteOutlined } from "@ant-design/icons"

import { DeleteConfirm } from "@src/app/components/DeleteConfirm"
import { notify } from "@src/app/components/notify"
import {
  Domain,
  DomainsCollection,
} from "@src/pages/settingsDomain/classes/DomainsCollection"
import { WithCollection } from "@src/shared/classes/Collection/types"

type Props = WithCollection<DomainsCollection>
export const DomainsTable = observer(({ collection }: Props) => {
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false)

  const [toDelete, setToDelete] = useState("")

  const showDeleteConfirm = (id: string) => {
    setToDelete(id)

    setOpenDeleteConfirm(true)
  }

  const onDeleteConfirm = () => {
    collection.delete(toDelete).finally(() => {
      notify.success("Domain has been deleted")

      setOpenDeleteConfirm(false)
    })
  }

  const columns: ColumnsType<Domain> = computed(() => {
    const loading = collection.projects.isLoading

    return [
      {
        align: "center",
        dataIndex: "project_name",
        render: (_, { project_id }) =>
          loading ? (
            <Skeleton.Input active style={{ height: 20 }} />
          ) : (
            collection.projects.getByKey({ id: project_id })?.name ?? "-"
          ),
        title: "Project Name",
      },
      {
        align: "center",
        dataIndex: "url",
        title: "Domain",
      },
      {
        align: "center",
        render: (_, { id }) => (
          <Button
            icon={<DeleteOutlined />}
            loading={collection.isLoading}
            onClick={() => showDeleteConfirm(id!)}
            type="text"
          />
        ),
        title: "Action",
      },
    ] as ColumnsType<Domain>
  }).get()

  return (
    <>
      <Table
        columns={columns}
        dataSource={collection.items}
        loading={collection.isLoading}
        pagination={collection.pagination}
      />

      <DeleteConfirm
        cancelText="Cancel"
        isLoading={collection.isLoading}
        okText="Delete Domain"
        onCancel={() => setOpenDeleteConfirm(false)}
        onOk={onDeleteConfirm}
        open={openDeleteConfirm}
        text="This action cannot be undone"
        title="Are you sure you want to delete this domain?"
      />
    </>
  )
})
